module.exports = __webpack_public_path__ + "img/qy3@2x.b1855165.png";